module.exports = __webpack_public_path__ + "static/media/toon.486cfd62.png";